import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-ep-date-input',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EpDateInputComponent),
            multi: true
        }
    ],
    templateUrl: './ep-date-input.component.html',
    styleUrls: ['./ep-date-input.component.scss'],
    standalone: false
})
export class EpDateInputComponent implements ControlValueAccessor {
  date: string;
  invalid = false;
  @Input() height;
  @Input() width;

  detectChange(value) {
    this.onChange(value);
    this.invalid = false;
    const arr = value.split('/');
    for (const str of arr) {
      for (const item of str) {
        if (item < '0' || item > '9') { return; }
      }
    }
    this.date = value;
  }

  onClick() {
    this.invalid = false;
  }

  onBlur(event: Event) {
    this.onTouched();
    this.date = (<HTMLInputElement>event.target).value;
    const arr = this.date.split('/');
    for (const str of arr) {
      for (const item of str) {
        if (item < '0' || item > '9') { return this.invalid = true; }
      }
    }
    // this.getDate.emit(this.date);
    this.invalid = false;

  }

  // tslint:disable
  onChange = (value) => { };
  onTouched = () => { };
  // tslint:enable
  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(value) {
    this.date = value ? value : ''; // reactive form 给search设初值
  }

  setDisabledState(isDisabled: boolean) {
    // this.disabled = isDisabled;
  }

}
